/**
 * Configuration centralisée de l'API
 * Tous les services doivent importer API_BASE_URL depuis ce fichier
 */

// URL de base de l'API backend
// En développement : '/api' (proxy vers localhost:8098) pour la production
// En production : peut être configuré via variable d'environnement
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

